module.exports = __webpack_public_path__ + "static/img/board.e27081d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/f2/board.png
// module id = 4Mpk
// module chunks = 0